import { Grid, Typography } from '@mui/material'

import { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { usePageTracking } from '@services/hooks/useGoogleAnalytics'
import { GA_CONFIG, PAGE_TRACKING_DATA } from '@features/config/analytics'

import { useToggleBar } from '@components/ToggleBar/use'
import { AWS, AZURE, DISCONNECTED, useLandingZones } from '@features/hooks/LandingZones'

import ToggleBar from '@components/ToggleBar'
import LzCard from '@views/Landingzones/List/LzCard'

export const List = () => {
    const dataStore = useSelector(state => state.landingZones)

    const { load: loadLz } = useLandingZones()

    const [lzs, setLzs] = useState([])
    const [displayToggle, setDisplayToggle] = useState('none')
    const [provider, setProvider] = useState(null)

    usePageTracking({
        ...GA_CONFIG.default_data,
        ...PAGE_TRACKING_DATA.lz.list
    })

    useEffect(() => {
        if (!(dataStore.formated.mode > -1)) loadLz()
    }, [])

    const { buttons, selected, onChange } = useToggleBar([
        {id: AZURE, label: 'Azure'},
        {id: AWS, label: 'AWS'}
    ], AZURE)

    useEffect(() => {
        setLzs(dataStore.formated.list)
    }, [dataStore.formated.list])

    useEffect(() => {
        if (dataStore.formated.mode === 0) {
            setProvider(null)
            return setDisplayToggle('none')
        }

        if (dataStore.formated.mode === 1) {
            setProvider(AZURE)
            return setDisplayToggle('none')
        }

        if (dataStore.formated.mode === 2) {
            setProvider(AWS)
            return setDisplayToggle('none')
        }

        if (dataStore.formated.mode === 3) setDisplayToggle('flex')
    }, [dataStore.formated.mode])

    return (
        <Fragment>
            <Typography variant={'h2'} sx={{mt: 1}}>Landing zones</Typography>

            <ToggleBar
                buttons={buttons}
                selected={selected}
                onChange={onChange}
                variant={'secondary'}
                width={'150px'}
                style={{marginTop: '24px', display: displayToggle}}
            />

            <Grid container spacing={3} sx={{mt: 1}}>
                {lzs && lzs.length > 0 && lzs.map(lz => {

                    if (displayToggle === 'flex') {
                        if (selected !== lz.provider) return
                    } else if (provider !== lz.provider) return

                    return (
                        <Grid key={lz.id}>
                            <LzCard
                                id={lz.id}
                                azure={(lz.provider === AZURE)}
                                aws={(lz.provider === AWS)}
                                subscription={lz.subscription}
                                mode={lz.mode}
                                // needMigration={(lz.provider === AZURE)}
                                needMigration={false}
                                disconnected={(lz.mode === DISCONNECTED)}
                            />
                        </Grid>
                    )
                })}
            </Grid>
        </Fragment>
    )
}

export default List